import React from 'react';

import SelectionModal from './abstract/modal';

function renderPerson(person) {
  return <React.Fragment>
    <strong>{person.name}</strong>
  </React.Fragment>;
}

const ContactsPeopleSelectionModal = props => (
  <SelectionModal
    itemLabel="users"
    queryKey="first_name_or_last_name_or_email_cont"
    renderItem={renderPerson}
    searchPath="/contacts/people.json"
    searchPlaceholder="Enter a user's name or email address"
    {...props}
  />
);

export default ContactsPeopleSelectionModal;
